import API from "../api/axios";

// ─── Get All Projects ───
export const getProjects = () => {
   return API.get("/projects");
};

// ─── Create Project ───
export const createProject = (data) => {
   return API.post("/projects", data);
};

// ─── Update Project ───
export const updateProject = (id, data) => {
   return API.put(`/projects/${id}`, data);
};

// ─── Delete Project ───
export const deleteProject = (id) => {
   return API.delete(`/projects/${id}`);
};